import { useAuth } from '@/features/auth/useAuth'
import { ENROLLED_COURSES_FILTER } from './useGetEnrolledCoursesFilter'

export const useGetEnrolledCourseTermsFilter = () => {
  const { user } = useAuth()
  const userFilter = user ? `["userId", "=", "${user.id}"]` : ''

  const finalFilter = [ENROLLED_COURSES_FILTER, userFilter].filter(Boolean).join(', "and", ')

  return { filter: `[${finalFilter}]`, select: `["termId"]` }
}
